import { Component, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { environment } from '../../../environments/environment';
import { HelperService } from '../../services/helper.service';
import { SupaService } from '../../services/supa.service';
import {decode} from 'base64-arraybuffer';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {

  loadingDone = false;

  reddays = 5;
  amberdays = 30;
  lang1name = 'English';
  lang1code = 'EN';
  lang2enabled = true;
  lang2name = 'Arabic';
  lang2code = 'AR';
  lang1currency = '€';
  lang2currency = '€';
  defaulttax = 0.21;
  maxtimepre = 20
  maxtimempi = 20
  maxtimejp = 20
  maxtimeauth = 20
  maxtimeqi = 20
  maxtimeprejp = 20
  maxtimepreauth = 20

  videocalls = 'disable';

  helpurl='https://www.youtube.com/embed/shkbe-uQDHo';

  constructor(private helper: HelperService, private supa: SupaService, private loadingController: LoadingController) { }

  ngOnInit() {
    this.loadData();
  }

  async onSave() {
    this.loadingDone = false;
    const loading = await this.loadingController.create({
      message: 'Saving the new settings',
      spinner: 'bubbles'
    });
    await loading.present();

    const saveResult = await this.supa.supabase.from('settings').update({
      vhc_red_days: this.reddays,
      vhc_amber_days: this.amberdays,
      vhc_lang_1_name: this.lang1name,
      vhc_lang_1_code: this.lang1code,
      vhc_lang_2_enabled: this.lang2enabled,
      vhc_lang_2_name: this.lang2name,
      vhc_lang_2_code: this.lang2code,
      vhc_lang_1_currency: this.lang1currency,
      vhc_lang_2_currency: this.lang2currency,
      vhc_default_tax: this.defaulttax,
      vhc_video_calls: this.videocalls,
      vhc_max_time_pre: this.maxtimepre,
      vhc_max_time_mpi: this.maxtimempi,
      vhc_max_time_jp: this.maxtimejp,
      vhc_max_time_auth: this.maxtimeauth,
      vhc_max_time_qi: this.maxtimeqi,
      vhc_max_time_pre_jp: this.maxtimeprejp,
      vhc_max_time_pre_auth: this.maxtimepreauth,
    }).neq('id', -1);

    if (saveResult.error) {
      this.loadingDone = true;
      this.helper.notify('Could not save the updated settings', 'danger');
      loading.dismiss();
      return;
    } 
    
    this.helper.notify('Settings were saved', 'success');
    loading.dismiss();
    this.loadingDone = true;
  }


  async loadData() {
    const settings = await this.supa.Settings();

    this.reddays = settings.reddays;
    this.amberdays = settings.amberdays;
    this.lang1name = settings.lang1name;
    this.lang1code = settings.lang1code;
    this.lang2enabled = settings.lang2enabled;
    this.lang2name = settings.lang2name;
    this.lang2code = settings.lang2code;
    this.lang1currency = settings.lang1currency;
    this.lang2currency = settings.lang2currency;
    this.defaulttax = settings.defaulttax;
    this.videocalls = settings.videocalls;
    this.maxtimepre = settings.maxtimepre;
    this.maxtimempi = settings.maxtimempi;
    this.maxtimejp = settings.maxtimejp;
    this.maxtimeauth = settings.maxtimeauth;
    this.maxtimeqi = settings.maxtimeqi;
    this.maxtimeprejp = settings.maxtimeprejp;
    this.maxtimepreauth = settings.maxtimepreauth;

    this.loadingDone = true;
  }
}

export interface ExternalConfig {
  id: number;
  name: string;
  data: any;
  logo: string;
}
